import { TypedPath } from '../../../types/routes';

const producerBasePath = '/producer';

export const ProducerNavigation = {
  basePath: producerBasePath,
  accessoriesInventoryList: {
    pathPattern: () => {
      return `${producerBasePath}/delivery-unit/:deliveryUnitId/accessories-iventory`;
    },
    pathFromParams: params => {
      return `${producerBasePath}/delivery-unit/${params.deliveryUnitId}/accessories-iventory`;
    },
    paramsFromPath: (match: any) => {
      return { deliveryUnitId: match.params.deliveryUnitId };
    }
  } as TypedPath<{ deliveryUnitId: string }>,
  piecesInventoryList: {
    pathPattern: () => {
      return `${producerBasePath}/delivery-unit/:deliveryUnitId/pieces-iventory`;
    },
    pathFromParams: params => {
      return `${producerBasePath}/delivery-unit/${params.deliveryUnitId}/pieces-iventory`;
    },
    paramsFromPath: (match: any) => {
      return { deliveryUnitId: match.params.deliveryUnitId };
    }
  } as TypedPath<{ deliveryUnitId: string }>,
  deliveryUnitSaleCatalogList: {
    pathPattern: () => {
      return `${producerBasePath}/delivery-unit/:deliveryUnitId/delivery-unit-sale-catalogs`;
    },
    pathFromParams: params => {
      return `${producerBasePath}/delivery-unit/${params.deliveryUnitId}/delivery-unit-sale-catalogs`;
    },
    paramsFromPath: (match: any) => {
      return { deliveryUnitId: match.params.deliveryUnitId };
    }
  } as TypedPath<{ deliveryUnitId: string }>,
  deliveryUnitSaleCatalogDetail: {
    pathPattern: () => {
      return `${producerBasePath}/delivery-unit/:deliveryUnitId/delivery-unit-sale-catalogs/:deliveryUnitSaleCatalogId`;
    },
    pathFromParams: params => {
      return `${producerBasePath}/delivery-unit/${params.deliveryUnitId}/delivery-unit-sale-catalogs/${params.deliveryUnitSaleCatalogId}`;
    },
    paramsFromPath: (match: any) => {
      return {
        deliveryUnitId: match.params.deliveryUnitId,
        deliveryUnitSaleCatalogId: match.params.deliveryUnitSaleCatalogId
      };
    }
  } as TypedPath<{
    deliveryUnitId: string;
    deliveryUnitSaleCatalogId: string;
  }>,
  deliveryUnitActiveSaleCatalogPreview: {
    pathPattern: () => {
      return `${producerBasePath}/delivery-unit/:deliveryUnitId/delivery-unit-active-sale-preview`;
    },
    pathFromParams: params => {
      return `${producerBasePath}/delivery-unit/${params.deliveryUnitId}/delivery-unit-active-sale-preview`;
    },
    paramsFromPath: (match: any) => {
      return {
        deliveryUnitId: match.params.deliveryUnitId
      };
    }
  } as TypedPath<{
    deliveryUnitId: string;
  }>,
  platformProducerOrderList: {
    pathPattern: () => {
      return `${producerBasePath}/delivery-unit/:deliveryUnitId/platform-producer-orders`;
    },
    pathFromParams: params => {
      return `${producerBasePath}/delivery-unit/${params.deliveryUnitId}/platform-producer-orders`;
    },
    paramsFromPath: (match: any) => {
      return { deliveryUnitId: match.params.deliveryUnitId };
    }
  } as TypedPath<{ deliveryUnitId: string }>,
  platformProducerOrderDetail: {
    pathPattern: () => {
      return `${producerBasePath}/delivery-unit/:deliveryUnitId/platform-producer-orders/:orderId`;
    },
    pathFromParams: params => {
      return `${producerBasePath}/delivery-unit/${params.deliveryUnitId}/platform-producer-orders/${params.orderId}`;
    },
    paramsFromPath: (match: any) => {
      return { deliveryUnitId: match.params.deliveryUnitId, orderId: match.params.orderId };
    }
  } as TypedPath<{ deliveryUnitId: string; orderId: string }>,
  accessoryList: {
    pathPattern: () => {
      return `${producerBasePath}/accessories`;
    },
    pathFromParams: _params => {
      return `${producerBasePath}/accessories`;
    },
    paramsFromPath: (_match: any) => {
      return {};
    }
  } as TypedPath<{}>,
  accessoryDetails: {
    pathPattern: () => {
      return `${producerBasePath}/accessories/:accessoryId`;
    },
    pathFromParams: params => {
      return `${producerBasePath}/accessories/${params.accessoryId}`;
    },
    paramsFromPath: (match: any) => {
      return { accessoryId: match.params.accessoryId };
    }
  } as TypedPath<{ accessoryId: string }>,
  pieceList: {
    pathPattern: () => {
      return `${producerBasePath}/pieces`;
    },
    pathFromParams: _params => {
      return `${producerBasePath}/pieces`;
    },
    paramsFromPath: (_match: any) => {
      return {};
    }
  } as TypedPath<{}>,
  pieceDetails: {
    pathPattern: () => {
      return `${producerBasePath}/pieces/:pieceId`;
    },
    pathFromParams: params => {
      return `${producerBasePath}/pieces/${params.pieceId}`;
    },
    paramsFromPath: (match: any) => {
      return { pieceId: match.params.pieceId };
    }
  } as TypedPath<{ pieceId: string }>,
  fontList: {
    pathPattern: () => {
      return `${producerBasePath}/fonts`;
    },
    pathFromParams: _params => {
      return `${producerBasePath}/fonts`;
    },
    paramsFromPath: (_match: any) => {
      return {};
    }
  } as TypedPath<{}>,
  fontDetails: {
    pathPattern: () => {
      return `${producerBasePath}/fonts/:fontId`;
    },
    pathFromParams: params => {
      return `${producerBasePath}/fonts/${params.fontId}`;
    },
    paramsFromPath: (match: any) => {
      return { fontId: match.params.fontId };
    }
  } as TypedPath<{ fontId: string }>,
  symbolCollectionList: {
    pathPattern: () => {
      return `${producerBasePath}/symbols`;
    },
    pathFromParams: _params => {
      return `${producerBasePath}/symbols`;
    },
    paramsFromPath: (_match: any) => {
      return {};
    }
  } as TypedPath<{}>,
  symbolCollectionDetails: {
    pathPattern: () => {
      return `${producerBasePath}/symbols/:symbolCollectionId`;
    },
    pathFromParams: params => {
      return `${producerBasePath}/symbols/${params.symbolCollectionId}`;
    },
    paramsFromPath: (match: any) => {
      return { symbolCollectionId: match.params.symbolCollectionId };
    }
  } as TypedPath<{ symbolCollectionId: string }>,
  support: {
    pathPattern: () => {
      return `${producerBasePath}/support`;
    },
    pathFromParams: _params => {
      return `${producerBasePath}/support`;
    },
    paramsFromPath: (_match: any) => {
      return {};
    }
  } as TypedPath<{}>
};
